import React from 'react';
import PropTypes from 'prop-types';
import TryAgainMessage from '../TryAgainMessage';

const tryAgainPageWrapperDefaultPropOnReset = () => {};
const TryAgainPageWrapper = ({
  error = null,
  onReset = tryAgainPageWrapperDefaultPropOnReset,
  children
}) => {
  return (
    <>
      {error ? <TryAgainMessage error={error} onReset={onReset} /> : children}
    </>
  );
};

TryAgainPageWrapper.propTypes = {
  error: PropTypes.objectOf(PropTypes.shape()),
  onReset: PropTypes.func,
  children: PropTypes.node.isRequired
};

export default TryAgainPageWrapper;
